import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const DepositInvoiceEditView = React.lazy(() => import('@/modules/depositInvoiceV2/deposit-invoice-edit-view'))

const depositInvoiceRoutes = (
  <>
    <Route path='depositinvoice/*' element={<RedirectToPlural />} />
    <Route path='depositinvoices/new/project/:projectId?' Component={DepositInvoiceEditView} />
    <Route path='depositinvoices/new/order/:orderId' Component={DepositInvoiceEditView} />
    <Route path='depositinvoices/new/:customerDepositId?/:orderId?' Component={DepositInvoiceEditView} />
    <Route path='depositinvoices/edit/:id' Component={DepositInvoiceEditView} />
  </>
)

export default depositInvoiceRoutes
